import React, { useState } from "react";
import Notification from "../../elements/notification/Notification";
import SystemCommandList from "./SystemCommandList";

import { StyledContentWrapper } from "../../styles/styledMain";

const SystemCommandContainer = () => {

  const [notification, setNotification] = useState({
    visible: false,
    type: "",
    message: ""
  });

  return (
    <StyledContentWrapper>
      <Notification
        notification={notification}
        setNotification={setNotification}
      />
      <SystemCommandList
        notification={notification}
        setNotification={setNotification}
      />
    </StyledContentWrapper>
  );
};

export default SystemCommandContainer;